export function renderMobileStoreCard({ document, card, store }) {
  const closeButton = document.createElement("button")
  closeButton.type = "button"
  closeButton.className = "map-store-card__close"
  closeButton.setAttribute("aria-label", "Cerrar")
  closeButton.setAttribute("data-action", "click->map#hideStoreCard")
  const closeIcon = document.createElement("i")
  closeIcon.className = "bi bi-x-lg"
  closeIcon.setAttribute("aria-hidden", "true")
  closeButton.append(closeIcon)

  const link = document.createElement("a")
  link.href = store.link
  link.className = `map-store-card__link${store.closed ? " is-closed" : ""}`

  const imageContainer = document.createElement("span")
  imageContainer.className = "map-store-card__img"

  if (store.headerUrl) {
    const image = document.createElement("img")
    image.src = store.headerUrl
    image.alt = store.name ?? ""
    imageContainer.append(image)
  }

  if (store.discount > 0 && !store.closed) {
    // Mismo pill esmerilado que la card del listado: "Hasta 45%" con etiqueta
    const discount = document.createElement("span")
    discount.className = "map-store-card__discount"
    const discountIcon = document.createElement("i")
    discountIcon.className = "fas fa-tag"
    discountIcon.setAttribute("aria-hidden", "true")
    discount.append(discountIcon, ` Hasta ${store.discount}%`)
    imageContainer.append(discount)
  }

  const body = document.createElement("span")
  body.className = "map-store-card__body"

  const name = document.createElement("span")
  name.className = "map-store-card__name"
  name.textContent = store.name ?? ""
  body.append(name)

  if (store.description) {
    const description = document.createElement("span")
    description.className = "map-store-card__desc"
    description.textContent = store.description
    body.append(description)
  }

  const meta = document.createElement("span")
  meta.className = "map-store-card__meta"

  if (store.distance) {
    const distance = document.createElement("span")
    distance.className = "map-store-card__distance"
    const distanceIcon = document.createElement("i")
    distanceIcon.className = "fas fa-location-dot"
    distance.append(distanceIcon, ` ${store.distance}`)
    meta.append(distance)
  }

  const delivery = document.createElement("span")
  delivery.className = `map-store-card__delivery ${store.delivery ? "is-on" : "is-off"}`
  const deliveryIcon = document.createElement("i")
  deliveryIcon.className = "fas fa-motorcycle"
  delivery.append(deliveryIcon, store.delivery ? " Delivery" : " Sin delivery")
  meta.append(delivery)
  body.append(meta)

  // Cerrada: mostramos cuándo abre y no mostramos el descuento, igual que el listado.
  if (store.closed && store.openLabel) {
    const closed = document.createElement("span")
    closed.className = "map-store-card__closed"
    const closedIcon = document.createElement("i")
    closedIcon.className = "fas fa-clock"
    closed.append(closedIcon, ` ${store.openLabel}`)
    body.append(closed)
  }

  link.append(imageContainer, body)
  card.replaceChildren(closeButton, link)
}
